import InviteApplicant from "./invite-applicant/InviteApplicant";
import Footer from "../../core/common/Footer";

const CreateNewOrder = () => {
  const CaseMark = () => (
    <svg
      className="tcp-case-mark"
      viewBox="0 0 40 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="14" width="4" height="18" rx="1.5" />
      <rect x="9" y="8" width="4" height="24" rx="1.5" />
      <rect x="18" y="0" width="4" height="32" rx="1.5" />
      <rect x="27" y="10" width="4" height="22" rx="1.5" />
      <rect x="36" y="18" width="4" height="14" rx="1.5" />
    </svg>
  );
  return (
    <div className="page-wrapper">
      <div className="content p-0 p-md-3">
        <div className="tcp-header-title-row mb-3">
          <CaseMark />
          <div>
            <h4 className="tcp-title">Create New Order</h4>
            <p className="tcp-subtitle">
              Create applicant invitations by selecting the organization,
              account, program, department, and screening package.
            </p>
          </div>
        </div>
        <InviteApplicant />
      </div>
      <Footer />
    </div>
  );
};

export default CreateNewOrder;
